import { AbstractControl } from "@angular/forms";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PasswordValidator {
  static MatchPassword(control: AbstractControl) {
    let password = control.get("password").value;
    let confirmPassword = control.get("cpassword").value;
    if (password !== confirmPassword) {
      control.get("cpassword").setErrors({ mismatchedPasswords: true });
      return {
        mismatchedPasswords: true,
      };
    } else {
      control.get("cpassword").setErrors(null);
      return null;
    }
  }
}
